module.exports = __webpack_public_path__ + "img/chair.df136b81.jpg";